import { getUnixTime } from 'date-fns';
import { StoreDateField } from 'app/models/types/store/date';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const date = new Date();
const defaultState: StoreDateField = {
  departureDate: getUnixTime(date),
  returnDate: getUnixTime(date),
  returnDateVisible: false,
};

export const dateSlice = createSlice({
  name: 'date',
  initialState: defaultState,
  reducers: {
    setDepartureDate(state, { payload: { date } }: PayloadAction<{ date: number }>) {
      state.departureDate = date;

      if (!state.returnDateVisible) {
        state.returnDate = date;
      } else {
        state.returnDate = Math.max(date, state.returnDate);
      }
    },
    setReturnDate(state, { payload: { date } }: PayloadAction<{ date: number }>) {
      state.returnDate = Math.max(date, state.departureDate);
    },
    toggleReturnDate(state, { payload: { isVisible } }: PayloadAction<{ isVisible: boolean }>) {
      state.returnDateVisible = isVisible;

      if (!isVisible) {
        state.returnDate = state.departureDate;
      }
    },
  },
});

export default dateSlice.reducer;

export const { setDepartureDate, setReturnDate, toggleReturnDate } = dateSlice.actions;
